import { Inject, Injectable, Renderer2 } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SharedEnvironment, SHARED_ENVIRONMENT } from '@sd-portal/shared/environment';
import { filter } from 'rxjs/operators';
import { GoogleAnalyticsEvent } from '../enums/google-analytics-event.enum';

// provides Angular app access to ga function
// eslint-disable-next-line @typescript-eslint/ban-types
declare let gtag: Function;

@Injectable({
  providedIn: 'root'
})
export class GoogleAnalyticsTrackingService {
  private readonly analyticsTrackingID: string;
  private preventBATLoadTrigger: boolean = false;

  constructor(
    @Inject(SHARED_ENVIRONMENT) private readonly environment: SharedEnvironment,
    private readonly router: Router
  ) {
    this.analyticsTrackingID = this.environment.analyticsTrackingID;
  }

  initAnalytics(): void {
    // nav end listener
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd && this.analyticsTrackingID.length > 0))
      .subscribe((event: NavigationEnd) => {
        gtag('config', this.analyticsTrackingID, {
          page_path: event.urlAfterRedirects
          //debug_mode: true
        });
      });
  }

  insertAnalyticsScriptTags(document: Document, renderer: Renderer2): void {
    if (this.analyticsTrackingID.length > 0) {
      const gaSrcScript = renderer.createElement('script');
      const gaFuncScript = renderer.createElement('script');

      gaSrcScript.async = true;
      gaSrcScript.type = 'text/javascript';
      gaSrcScript.src = 'https://www.googletagmanager.com/gtag/js?id=' + this.analyticsTrackingID;

      gaFuncScript.type = 'text/javascript';
      gaFuncScript.text =
        "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());";

      renderer.appendChild(document.head, gaSrcScript);
      renderer.appendChild(document.head, gaFuncScript);
    }
  }

  triggerEvent(event: GoogleAnalyticsEvent): void {
    if (this.analyticsTrackingID.length == 0) {
      return;
    }

    let triggerEvent = true;

    switch (event) {
      case GoogleAnalyticsEvent.BATLoadVertical:
      case GoogleAnalyticsEvent.BATLoadHorizontal:
      case GoogleAnalyticsEvent.BATLoadByLeg: {
        triggerEvent = !this.preventBATLoadTrigger;
        this.preventBATLoadTrigger = false;
        break;
      }

      case GoogleAnalyticsEvent.BATViewChangedVertical:
      case GoogleAnalyticsEvent.BATViewChangedHorizontal:
      case GoogleAnalyticsEvent.BATViewChangedByLeg: {
        const BBLurl = '/pre-flight/schedule-beta/';
        this.preventBATLoadTrigger =
          (event === GoogleAnalyticsEvent.BATViewChangedByLeg &&
            !this.router.url.includes(BBLurl)) ||
          ((event === GoogleAnalyticsEvent.BATViewChangedVertical ||
            event === GoogleAnalyticsEvent.BATViewChangedHorizontal) &&
            this.router.url.includes(BBLurl));
        break;
      }
    }

    if (triggerEvent) {
      gtag('event', event);
    }
  }
}
